module.exports = __webpack_public_path__ + "img/about-1.2e339338.webp";